import { Role, stringToRole } from "../types/User";

export const PRICING_PATH = "/pricing";

export const paidLevels = ["BRONZE", "SILVER", "GOLD"];

export type PricingRouteContext = {
  isAuthenticated: boolean;
  role?: Role | string | null;
};

export function normalizeRole(role: Role | string | null | undefined): Role | null {
  if (!role) return null;
  return typeof role === "string" ? stringToRole(role) : role;
}

export function isUnpaidRole(role: Role | string | null | undefined): boolean {
  return normalizeRole(role) === Role.USER;
}

/** Bronze and up. Admins are not paying members, so they can still walk the funnel. */
export function isPaidRole(role: Role | string | null | undefined): boolean {
  const normalized = normalizeRole(role);
  return (
    normalized === Role.BRONZE || normalized === Role.SILVER || normalized === Role.GOLD
  );
}

/**
 * Post-checkout / "where do I send a paid user from a generic CTA?"
 * routing. Each tier lands on its highest-value entry point so paid
 * users do not get bounced back through the pricing page.
 */
export function getPathFromAccess(accessLevel: Role | string | null | undefined): string {
  const role = normalizeRole(accessLevel);
  if (role === Role.ADMIN) return "/admin";
  if (role === Role.GOLD) return "/positive-ev";
  if (role === Role.SILVER) return "/parlay-builder";
  if (role === Role.BRONZE) return "/positive-ev";
  return "/";
}

export function shouldRouteToPricing({ isAuthenticated, role }: PricingRouteContext): boolean {
  return !isAuthenticated || isUnpaidRole(role);
}

/**
 * For generic CTAs only. A paid user gets their own product back, so an upgrade
 * CTA must go to PRICING_PATH instead, which shows paid users "Upgrade to <Tier>".
 */
export function getPricingDestination(context: PricingRouteContext): string {
  return shouldRouteToPricing(context) ? PRICING_PATH : getPathFromAccess(context.role);
}

